import type {ServerWebExchange} from '../../types/web/server';

const serverHeader = (version: string, server?: string | false) => {
    server ??= version;
    return async ({ response }: ServerWebExchange, next: () => Promise<void>) => {
        if (server !== false && !response.headers.has('server')) {
            response.headers.set('Server', server);
        }
        await next();
    }
};

export default (version: string, server?: string | false) => serverHeader(version, server);
